//@flow

const categories = {
  NUTRITION: {
    wheat_free: 'Made without gluten',
    protein_packed: 'Good source of protein',
    fiber_filled: 'Good source of fiber',
    paleo: 'Paleo-friendly',
    keto: 'Keto-friendly',
    vegan: 'Vegan',
    no_sugar_added: 'No sugar added',
    low_sugars: 'Less than 10g sugar',
    non_gmo: 'Non-GMO',
    low_fat: 'Low fat',
    low_sodium: 'Low sodium',
    low_calories: 'Less than 150 calories',
    low_carb: 'Less than 15g carbs',
  },
  TASTE: {
    savory: 'Savory',
    sweet: 'Sweet',
    spicy: 'Spicy',
  },
};

export default categories;
